import { ROUTE_PATH } from '@/constants/routePaths';

export const BREADCRUMBS = {
  visible: true,
  items: [
    {
      title: 'MY LEARNING ',
      path: ROUTE_PATH.MY_LEARNING_ONGOING,
    },
    {
      title: 'ASSIGNED',
      path: ROUTE_PATH.MY_LEARNING_ASSIGNED,
    },
  ],
};
